import { FEEDBACK_VIEW_KEY } from "./feedbackViewRestore";
import { useRegisterFeedbackContext } from "./useRegisterFeedbackContext";

/**
 * Contribute the page's restorable view state — tab, picks, toggles, whether
 * data was applied — to feedback reports, under `context.view`. Keep it to
 * what the page can set back: the getter is read lazily at submit time, like
 * `useRegisterFeedbackContext`.
 */
export function useRegisterFeedbackView(
  getView: () => Record<string, unknown>
): void {
  useRegisterFeedbackContext(() => ({ [FEEDBACK_VIEW_KEY]: getView() }));
}
